import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { Loader2 } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const AuthCallback = () => {
  const navigate = useNavigate();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash;
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) {
      navigate("/", { replace: true });
      return;
    }
    const session_id = decodeURIComponent(match[1]);

    (async () => {
      try {
        const res = await axios.post(`${API}/auth/session`, { session_id }, { withCredentials: true });
        // Clean URL and go to admin
        window.history.replaceState(null, "", "/admin");
        navigate("/admin", { replace: true, state: { user: res.data } });
      } catch (e) {
        navigate("/?auth_error=1", { replace: true });
      }
    })();
  }, [navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center" style={{ background: "var(--awd-bg)" }}>
      <div className="text-center">
        <Loader2 size={40} className="mx-auto animate-spin" style={{ color: "var(--awd-ochre)" }} />
        <p className="mt-4 font-display text-xl">Signing you in…</p>
      </div>
    </div>
  );
};

export default AuthCallback;
